/**
 * Puts text on the clipboard and says whether it got there.
 *
 * The console copies through `CopyableId`, which shows the value it copies;
 * a whole CSV is not something to show in a row, so the issuances page copies
 * through this instead, and says "Copied" or that the copy failed from what
 * it returns. That is the lint rule's point (a copy that failed must not look
 * like one that worked), and why this file is exempt from it
 * (infrastructure/linters/eslint/web.mjs, application/web/admin/CLAUDE.md).
 *
 * The clipboard is refused outside a secure context, without permission, and
 * where the browser has no clipboard API at all; each of those is false.
 */
export async function copyText(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
}
